const StagedFlowStatusEnum = {
  /// <summary>
  ///  In this status the staged flow is with valid structure
  /// </summary>
  Valid: 1,
  /// <summary>
  /// In this status the staged flow has some issues with the structure
  /// </summary>
  NotValid: 2,
  /// <summary>
  /// In this status the staged flow is ready for digital address check
  /// </summary>
  ReadyForDigitalAddressCheck: 3,
  /// <summary>
  /// In this status there was an issue calculating the price and there is no way to be fixed
  /// </summary>
  NotValidForPriceCalculation: 4,
  /// <summary>
  /// In this status the staged flow is ready to be processed for calculation
  /// </summary>
  ReadyForCalculation: 5,
  /// <summary>
  /// In this status the price for the notification was successfully calculated
  /// </summary>
  PriceCalculated: 6,
  /// <summary>
  /// In this status there was an issue calculating the price
  /// </summary>
  PriceNotCalculated: 7,
  /// <summary>
  /// In this status the staged flow is ready to be processed for technical authorization
  /// </summary>
  ReadyForTechAuthorization: 8,
  /// <summary>
  /// In this status the staged flow is started being checked by the Technical Manager
  /// </summary>
  TechAuthInProgress: 9,
  /// <summary>
  /// In this status the staged flow was authorized by the Technical Manager
  /// </summary>
  TechAuthorized: 10,
  /// <summary>
  /// In this status the staged flow was declined by the Technical Manager
  /// </summary>
  TechNotAuthorized: 11,
  /// <summary>
  /// In this status the staged flow is ready to be processed for economical authorization
  /// </summary>
  ReadyForEconAuthorization: 12,
  /// <summary>
  /// In this status the staged flow is started being checked by the Economical Manager
  /// </summary>
  EconAuthInProgress: 13,
  /// <summary>
  /// In this status the staged flow was authorized by the Economical Manager
  /// </summary>
  EconAuthorized: 14,
  /// <summary>
  /// This status is indication that the flow has been marked as Deleted
  /// </summary>
  Deleted: 15,
  /// <summary>
  /// In this status the staged flow is ready to be sent to EN CORE
  /// </summary>
  ReadyForSend: 16,
  /// <summary>
  /// This status is indication that the flow has been sent to EN CORE
  /// </summary>
  Sent: 17,
  /// <summary>
  /// In this status the staged flow was not financially approved and is returned to the Technical Manager
  /// </summary>
  EconNotApproved: 18,
};

export default StagedFlowStatusEnum;
